/* ITALAZA Bottega : date de livraison estimée.
   Remplit chaque [data-eg-delivery] à partir de ses attributs (posés par snippets/eg-delivery.liquid) :
   - data-min, data-max : délais en jours ouvrés (réglages delai_min et delai_max du thème) ;
   - data-locale : langue de la page (fr ou de ; toute autre langue garde le texte serveur) ;
   - data-cutoff (facultatif) : heure limite de commande, heure de Paris (0 à 23) ; au-delà (ou un jour non ouvré),
     le décompte part du jour ouvré suivant. Sans lui, le jour de la commande compte comme jour 0, comme avant.
   Sans JS, le texte serveur traduit (« sous 3 à 5 jours ouvrés ») reste affiché.
   Jours ouvrés : du lundi au vendredi, hors jours fériés nationaux français (audit C8 : une commande du 24 décembre
   ne doit pas annoncer une livraison qui compte le 25). La date reste une estimation : le libellé qui l'accompagne
   le dit (clé eg.livraison.chez_vous, « Livraison estimée chez vous »). */
(function () {
  /* Inclus une seule fois, mais protégé contre un double chargement. */
  if (window.__egDelivery) return;
  window.__egDelivery = true;

  var LANG = {
    fr: { tag: 'fr-FR', between: 'entre le ', and: ' et le ', single: 'le ' },
    de: { tag: 'de-DE', between: 'zwischen ', and: ' und ', single: 'am ' }
  };

  function todayInParis() {
    var parts = new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    var get = function (type) {
      return Number(parts.find(function (p) { return p.type === type; }).value);
    };
    return new Date(Date.UTC(get('year'), get('month') - 1, get('day')));
  }

  function parisHour() {
    var h = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', hourCycle: 'h23' }).format(new Date());
    return parseInt(h, 10);
  }

  /* Jours fériés nationaux français de l'année (clés « année-mois-jour », mois de 1 à 12). Pâques : algorithme de Meeus. */
  var feries = {};
  function holidays(y) {
    if (feries[y]) return feries[y];
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var easter = Date.UTC(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
    var set = {};
    var add = function (t) { var x = new Date(t); set[x.getUTCFullYear() + '-' + (x.getUTCMonth() + 1) + '-' + x.getUTCDate()] = true; };
    [[1, 1], [5, 1], [5, 8], [7, 14], [8, 15], [11, 1], [11, 11], [12, 25]].forEach(function (md) { add(Date.UTC(y, md[0] - 1, md[1])); });
    [1, 39, 50].forEach(function (n) { add(easter + n * 86400000); }); /* lundi de Pâques, Ascension, lundi de Pentecôte */
    feries[y] = set;
    return set;
  }
  function isBusinessDay(d) {
    var wd = d.getUTCDay();
    return wd !== 0 && wd !== 6 && !holidays(d.getUTCFullYear())[d.getUTCFullYear() + '-' + (d.getUTCMonth() + 1) + '-' + d.getUTCDate()];
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusinessDay(d)) days -= 1;
    }
    return d;
  }

  function label(minDays, maxDays, lang, cutoff) {
    var start = todayInParis();
    /* Heure limite réglée : une commande passée après elle, ou un jour non ouvré, est traitée le jour ouvré suivant. */
    if (cutoff >= 0 && (parisHour() >= cutoff || !isBusinessDay(start))) start = addBusinessDays(start, 1);
    var min = addBusinessDays(start, minDays);
    var max = addBusinessDays(start, maxDays);
    var dayNum = new Intl.DateTimeFormat(lang.tag, { timeZone: 'UTC', weekday: 'long', day: 'numeric' });
    var full = new Intl.DateTimeFormat(lang.tag, { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
    if (min.getTime() === max.getTime()) return lang.single + full.format(max);
    var first = min.getUTCMonth() === max.getUTCMonth() ? dayNum.format(min) : full.format(min);
    return lang.between + first + lang.and + full.format(max);
  }

  var cache = {};
  function fill(root) {
    var nodes = (root || document).querySelectorAll('[data-eg-delivery]:not([data-eg-done])');
    nodes.forEach(function (el) {
      el.setAttribute('data-eg-done', '');
      var code = (el.getAttribute('data-locale') || document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
      var lang = LANG[code];
      var a = parseInt(el.getAttribute('data-min'), 10);
      var b = parseInt(el.getAttribute('data-max'), 10);
      var cut = parseInt(el.getAttribute('data-cutoff'), 10);
      if (!(cut >= 0 && cut <= 23)) cut = -1;
      /* Réglages inversés (délai minimal > maximal, audit L16) : maximal ramené au minimal, comme le Liquid
         (at_least: d_min) ; jamais une date plus proche que le délai minimal réglé (relecture code). */
      if (a > b) b = a;
      if (!lang || !(a >= 0) || !(b >= a)) return;
      var key = code + a + '-' + b + '-' + cut;
      try { cache[key] = cache[key] || label(a, b, lang, cut); } catch (e) { return; }
      el.textContent = cache[key];
    });
  }

  function start() {
    fill();
    // Les sections rechargées (panier, encadré d'achat) apportent de nouveaux éléments : on les remplit.
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; fill(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
